import Api from "./Api.js";
import { getBaseUrl } from "@/api/ApiHelper";

const resource = "/shopify-discounts";

export default {
  update(discountId, data) {
    return Api.patch(`${resource}/${discountId}`, data, {
      baseURL: getBaseUrl("v2"),
    });
  },
};
